/* eslint-disable camelcase */
import router from '../../router/router'
import moment from 'moment'
import i18n from '../../locales/i18n'
import { resetStateToDefault, formataStringParaCaptalize, groupBy, copiarObjetoProfundamente } from '../../utils'
import { tratarErroDaSincronizacaoWeb, tratarErroDaSincronizacaoEmpregado } from './utils'
import { Http } from 'vue-resource'
import { gerarUrlSincronizacaoWeb, gerarUrlSincronizacaoUsuario } from '../../api'

const estadoPadrao = () => ({
  pin: '',
  sincronizacaoWeb: {
    cliente: null,
    empregadores: [],
    locais: [],
    perfilColetor: null
  },
  sincronizacaoUsuario: {
    empregado: null,
    jornada_do_dia: null,
    jornada_em_andamento: null,
    marcacoes: [],
    correcoes_de_marcacao: []
  },
  sincronizacaoWebFinalizada: false,
  tentativasSincronizacaoWeb: 0,
  tentativasSincronizacaoPin: 0,
  erroSincronizarPin: false
})

const getters = {
  empregadoSincronizado (state) {
    const empregado = state.sincronizacaoUsuario.empregado
    const empregadores = state.sincronizacaoWeb.empregadores
    const locaisSincronizacao = state.sincronizacaoWeb.locais
    if (empregado && locaisSincronizacao.length && empregadores.length) {
      const locaisDeTrabalho = empregado.locais_de_trabalho_id.map(empregadoLocal => {
        return locaisSincronizacao.find(empregadoresLocal => empregadoresLocal.id === empregadoLocal)
      })
      const empregador = empregadores.find(e => e.id === empregado.empregador_id)
      return {
        nome: formataStringParaCaptalize(empregado.nome),
        cpf: empregado.cpf,
        empregador,
        locais: locaisDeTrabalho
      }
    }
    return false
  },
  locaisColetor (state) {
    const locaisDeTrabalho = state.sincronizacaoWeb.locais

    if (locaisDeTrabalho.length) {
      return locaisDeTrabalho
    }
    return false
  },
  jornadaDoDia (state) {
    const jornadaDoDia = state.sincronizacaoUsuario.jornada_do_dia
    if (!jornadaDoDia) return false

    const { dia, inicio, pausa, retorno, fim, nome, tipo } = jornadaDoDia
    const diaDaJornada = moment(dia)
    const inicioJornada = moment(inicio)
    const pausaJornada = moment(pausa)
    const retornoJornada = moment(retorno)
    const fimJornada = moment(fim)

    const duracaoJornada = fimJornada.diff(inicioJornada)
    const duracaoPausa = retornoJornada.diff(pausaJornada)

    const duracaoJornadaFinal = moment.duration(duracaoJornada - duracaoPausa)
    const duracaoJornadaFinalHoras = Math.floor(duracaoJornadaFinal.asHours())
    const duracaoJornadaFinalMinutos = duracaoJornadaFinal.minutes()

    const duracaoJornadaFinalFormatada = duracaoJornadaFinalMinutos
      ? `${duracaoJornadaFinalHoras}h${duracaoJornadaFinalMinutos}min`
      : `${duracaoJornadaFinalHoras}h`

    const duracaoPausaFinalHoras = Math.floor(moment.duration(duracaoPausa).asHours())
    const duracaoPausaFinalMinutos = moment.duration(duracaoPausa).minutes()
    const duracaoPausaFormatada = duracaoPausaFinalHoras
      ? duracaoPausaFinalMinutos
        ? `${duracaoPausaFinalHoras}h${duracaoPausaFinalMinutos}min`
        : `${duracaoPausaFinalHoras}h`
      : `${duracaoPausaFinalMinutos}min`

    return {
      nome,
      tipo,
      dia: moment(diaDaJornada).format('DD/MM/YY'),
      inicio: moment(inicioJornada).format('HH:mm'),
      pausa: moment(pausaJornada).format('HH:mm'),
      retorno: moment(retornoJornada).format('HH:mm'),
      fim: moment(fimJornada).format('HH:mm'),
      duracaoJornada: duracaoJornadaFinalFormatada,
      duracaoPausa: duracaoPausaFormatada
    }
  },
  marcacoesAgrupadasETratadas (state) {
    const marcacoes = copiarObjetoProfundamente(state.sincronizacaoUsuario.marcacoes)
    const correcoesMarcacoes = copiarObjetoProfundamente(state.sincronizacaoUsuario.correcoes_de_marcacao)
    const jornada = state.sincronizacaoUsuario.jornada_do_dia

    const inicioJornada = jornada ? moment(jornada.inicio) : null
    const fimJornada = jornada ? moment(jornada.fim) : null
    const jornadaTerminaNoDiaSeguinte = jornada ? fimJornada.isAfter(inicioJornada, 'days') : null

    if (marcacoes.length === 0 && correcoesMarcacoes.length === 0) return []

    if (correcoesMarcacoes.length) {
      correcoesMarcacoes.forEach(correcao => {
        const marcacaoCorrecaoId = correcao.marcacao_id

        const marcacaoErrada = marcacoes.find(marcacao => marcacao.id === marcacaoCorrecaoId)
        if (!marcacaoErrada) {
          marcacoes.push({...correcao, origem: 'OUTRO'})
          return
        }

        const indexMarcacaoErrada = marcacoes.indexOf(marcacaoErrada)

        marcacoes.splice(indexMarcacaoErrada, 1)
        marcacoes.push({...correcao, origem: 'CORRECAO'})
      })
    }

    const marcacoesComJornadaDoDia = marcacoes.map(marcacao => {
      let jornadaDoDia

      if (jornadaTerminaNoDiaSeguinte) {
        const horasDeTolerancia = 3
        const horarioParametro = inicioJornada.hours() - horasDeTolerancia
        const horarioMarcacao = moment(marcacao.horario).hours()

        jornadaDoDia = moment(marcacao.horario).subtract(1, 'days')

        if (horarioMarcacao >= horarioParametro) {
          jornadaDoDia = moment(jornadaDoDia).add(1, 'days')
        }
      } else {
        jornadaDoDia = moment(marcacao.horario)
      }

      return {
        ...marcacao,
        jornadaDia: jornadaDoDia.format('DD/MM/YY')
      }
    })

    const marcacoesAgrupadasPorJornada = groupBy(marcacoesComJornadaDoDia, 'jornadaDia')

    return  marcacoesAgrupadasPorJornada
  },
  marcacoesDaJornada (state, getters) {
    const marcacoes = getters.marcacoesAgrupadasETratadas

    if (!marcacoes) return []

    const marcacoesPorJornada = marcacoes.reduce((acc, grupo) => {
      const jornada = grupo[0]
      const marcacoes = grupo[1]
      acc[jornada] = [...marcacoes]
      return acc
    }, {})

    return marcacoesPorJornada
  },
  marcacoesDaJornadaEmAndamento (state) {
    let jornadaEmAndamento = copiarObjetoProfundamente(state.sincronizacaoUsuario.jornada_em_andamento)
    const idReppEmpregado = state.sincronizacaoUsuario.empregado?.id_repp
    const todasMarcacoes = copiarObjetoProfundamente(state.sincronizacaoUsuario.marcacoes)
    const todasCorrecoes = copiarObjetoProfundamente(state.sincronizacaoUsuario.correcoes_de_marcacao)
    const momentosDaJornada = Object.freeze({
      entrada: 'Entrada',
      pausa: 'Pausa',
      retorno: 'Retorno Pausa',
      saida: 'Saída'
    })

    if (!jornadaEmAndamento) {
      jornadaEmAndamento = {
        correcoes_de_marcacao_id: [],
        marcacoes_id: []
      }
    }

    const marcacoesDoEmpregadoNoStorage = JSON.parse(window.localStorage.getItem(idReppEmpregado))

    const marcacoesIds = jornadaEmAndamento.marcacoes_id
    const correcoesIds = jornadaEmAndamento.correcoes_de_marcacao_id

    if (marcacoesDoEmpregadoNoStorage?.length) {
      marcacoesDoEmpregadoNoStorage.forEach(marcacaoStorage => {
        const marcacaoDoStorageEhDaJornadaDoDia = Boolean((marcacaoStorage.jornada === state.sincronizacaoUsuario?.jornada_do_dia?.dia) || (marcacaoStorage.jornada ===  moment().format('YYYY-MM-DD')))
        const marcacaoDoStorageEstaNoArrayDePontosNoReppComInfosExtras = Boolean(todasMarcacoes.find(m => m.id === marcacaoStorage.id))
        const marcacaoDoStorageEstaEmMarcacaoDoDia = Boolean(marcacoesIds.find(marcacaoId => marcacaoId === marcacaoStorage.id))

        if (!marcacaoDoStorageEhDaJornadaDoDia) {
          // Ponto no storage não pertence a jornada atual
          const index = marcacoesDoEmpregadoNoStorage.indexOf(marcacaoStorage)
          marcacoesDoEmpregadoNoStorage.splice(index, 1)
          window.localStorage.setItem(idReppEmpregado, JSON.stringify(marcacoesDoEmpregadoNoStorage))
          return
        }

        if (!marcacaoDoStorageEstaNoArrayDePontosNoReppComInfosExtras && !marcacaoDoStorageEstaEmMarcacaoDoDia) {
          // Ponto existe no rep-p, mas não tem infos-extras
          todasMarcacoes.push(marcacaoStorage)
          marcacoesIds.push(marcacaoStorage.id)
          return
        }

        if (marcacaoDoStorageEstaNoArrayDePontosNoReppComInfosExtras && marcacaoDoStorageEstaEmMarcacaoDoDia) {
          // Ponto está processado na folha, tudo OK
          const index = marcacoesDoEmpregadoNoStorage.indexOf(marcacaoStorage)
          marcacoesDoEmpregadoNoStorage.splice(index, 1)
          window.localStorage.setItem(idReppEmpregado, JSON.stringify(marcacoesDoEmpregadoNoStorage))
          return
        }

        if (marcacaoDoStorageEstaNoArrayDePontosNoReppComInfosExtras && !marcacaoDoStorageEstaEmMarcacaoDoDia) {
          // Ponto está no rep-p, mas não foi processado ainda
          marcacoesIds.push(marcacaoStorage.id)
        }
      })
    }

    const pontosDeCorrecao = correcoesIds.map(correcaoId => todasCorrecoes.find(tc => tc.id === correcaoId))
    const pontosDeMarcacao = marcacoesIds.map(marcacaoId => todasMarcacoes.find(tm => tm.id === marcacaoId))

    if (pontosDeCorrecao.length) {
      pontosDeCorrecao.forEach(correcao => {
        const marcacaoCorrecaoId = correcao.marcacao_id

        const marcacaoErrada = pontosDeMarcacao.find(marcacao => marcacao.id === marcacaoCorrecaoId)
        if (!marcacaoErrada) {
          pontosDeMarcacao.push({...correcao, origem: 'OUTRO'})
          return
        }

        const indexMarcacaoErrada = pontosDeMarcacao.indexOf(marcacaoErrada)

        pontosDeMarcacao.splice(indexMarcacaoErrada, 1)
        pontosDeMarcacao.push({...correcao, origem: 'CORRECAO'})
      })
    }
    const entrada = pontosDeMarcacao
      .filter(marcacao => marcacao.momento_da_jornada === momentosDaJornada.entrada)
      .sort((a, b) => moment(a.horario).diff(moment(b.horario)))
    const pausa = pontosDeMarcacao
      .filter(marcacao => marcacao.momento_da_jornada === momentosDaJornada.pausa)
      .sort((a, b) => moment(a.horario).diff(moment(b.horario)))
    const retorno = pontosDeMarcacao
      .filter(marcacao => marcacao.momento_da_jornada === momentosDaJornada.retorno)
      .sort((a, b) => moment(a.horario).diff(moment(b.horario)))
    const saida = pontosDeMarcacao
      .filter(marcacao => marcacao.momento_da_jornada === momentosDaJornada.saida)
      .sort((a, b) => moment(a.horario).diff(moment(b.horario)))

    return {
      entrada: entrada.length ? [...entrada] : [],
      pausa: pausa.length ? [...pausa] : [],
      retorno: retorno.length ? [...retorno] : [],
      saida: saida.length ? [...saida] : []
    }
  },
  coletorComRecaptcha (state) {
    const possuiRecaptcha = state.sincronizacaoWeb?.perfil_de_coletor.opcoes.seguranca.ativar_recaptcha
    return Boolean(possuiRecaptcha)
  }
}

const mutations = {
  resetState (state) {
    resetStateToDefault(state, estadoPadrao())
  },
  atribuiPin (state, pin) {
    state.pin = pin
  },
  atribuiSincronizacaoWeb (state, sincronizacao) {
    state.sincronizacaoWeb = sincronizacao
  },
  atribuiSincronizacaoUsuario (state, sincronizacaoUsuario) {
    state.sincronizacaoUsuario = sincronizacaoUsuario
  },
  atribuiErroSincronizarPin (state, status) {
    state.erroSincronizarPin = status
  },
  atribuiTentativasSincronizacaoPin (state, tentativas) {
    state.tentativasSincronizacaoPin = tentativas
  },
  atribuiTentativasSincronizacaoWeb (state, tentativas) {
    state.tentativasSincronizacaoWeb = tentativas
  },
  sincronizacaoWebFinalizada (state, status) {
    state.sincronizacaoWebFinalizada = status
  }
}

const actions = {
  async fazerSincronizacaoWeb ({ commit }, tempoParaFazerRequisicao = 5000) {
    commit('sincronizacaoWebFinalizada', false)
    try {
      const respostaDaAPI = await Http.get(gerarUrlSincronizacaoWeb(), { timeout: tempoParaFazerRequisicao })

      commit('atribuiSincronizacaoWeb', respostaDaAPI.body)
      commit('sincronizacaoWebFinalizada', true)
    } catch (erro) {
      tratarErroDaSincronizacaoWeb(erro)
    }
  },
  async fazerSincronizacaoUsuario ({ commit, state, dispatch }, elementoParaFocarAposFecharModal = null, tempoParaFazerRequisicao = 5000) {
    try {
      const respostaDaAPI = await Http.get(
        gerarUrlSincronizacaoUsuario(state.pin),
        {
          timeout: tempoParaFazerRequisicao,
          headers: {
            'accept-language': i18n.locale
          }
        }
      )

      const { empregado } = respostaDaAPI.body
      const { opcoes_de_marcacao, locais_de_trabalho_id } = empregado
      const locaisSincronizacaoWeb = state.sincronizacaoWeb.locais
      /*
        Primeiramente, tenta-se localizar o local de trabalho do empregado nos locais retornados na sincronização geral.
        Caso não encontre, significa que o local de trabalho desse empregado não está cadastrado no coletor, porem,
        caso o funcionário puder bater o ponto em qualquer local de trabalho, associamos o primeiro local da lista
        de locais de trabalho retornado na sincronização geral como default.
      */
      const localDeTrabalho = locaisSincronizacaoWeb.find(l => l.id === locais_de_trabalho_id[0]) || locaisSincronizacaoWeb[0]

      commit('localPadraoEmpregadoSincronizado', {id: localDeTrabalho.id, nome: localDeTrabalho.nome}, {root: true})
      commit('atribuiSincronizacaoUsuario', respostaDaAPI.body)
      commit('marcacao/atribuiEmpregadoId', empregado.id_repp, {root: true})
      commit('marcacao/atribuiOpcoesDeMarcacao', opcoes_de_marcacao, {root: true})
      dispatch('salvarTokenFirebase', empregado.id, { root: true })
      router.push({ name: 'confirmacaoDados' })
    } catch (erro) {
      tratarErroDaSincronizacaoEmpregado(erro, elementoParaFocarAposFecharModal)
    }
  },
  async fazerSincronizacaoWebSSO ({ dispatch }, tempoParaFazerRequisicao = 5000) {
    try {
      const respostaDaAPI = await Http.get(gerarUrlSincronizacaoWeb(), { timeout: tempoParaFazerRequisicao })

      dispatch('atribuirSincronizacaoWebSSO', respostaDaAPI.body)
      dispatch('fazerSincronizacaoUsuarioSSO')
    } catch (erro) {
      tratarErroDaSincronizacaoWeb(erro, true)
    }
  },
  async fazerSincronizacaoUsuarioSSO ({ commit, dispatch }, tempoParaFazerRequisicao = 5000) {
    try {
      const respostaDaAPI = await Http.get(gerarUrlSincronizacaoUsuario(), {timeout: tempoParaFazerRequisicao})

      commit('executingSAMLLogin', false, {root: true})
      dispatch('atribuirSincronizacaoUsuarioSSO', respostaDaAPI.body)
      commit('executingSAMLLogin', false, {root: true})
    } catch (erro) {
      tratarErroDaSincronizacaoEmpregado(erro, null, true)
    }
  },
  atribuirSincronizacaoWebSSO ({ commit }, sincronizacaoWeb) {
    commit('atribuiSincronizacaoWeb', sincronizacaoWeb)
  },
  atribuirSincronizacaoUsuarioSSO ({ state, commit, dispatch }, sincronizacaoUsuario) {
    const { confirmar_dados } = state.sincronizacaoWeb.perfil_de_coletor.opcoes.seguranca
    const { empregado } = sincronizacaoUsuario
    const { opcoes_de_marcacao, locais_de_trabalho_id, empregador_id } = empregado

    const locaisSincronizacaoWeb = state.sincronizacaoWeb.locais
    const localDeTrabalho = locaisSincronizacaoWeb.find(l => l.id === locais_de_trabalho_id[0]) || locaisSincronizacaoWeb[0]
    const localRepp = localDeTrabalho.locais_repp_por_empregador[empregador_id]

    commit('localPadraoEmpregadoSincronizado', {id: localDeTrabalho.id, nome: localDeTrabalho.nome}, {root: true})
    commit('atribuiSincronizacaoUsuario', sincronizacaoUsuario)
    commit('marcacao/atribuiEmpregadoId', empregado.id_repp, {root: true})
    commit('marcacao/atribuiOpcoesDeMarcacao', opcoes_de_marcacao, {root: true})
    commit('marcacao/atribuiMostrarRelogio', true, {root: true})
    dispatch('salvarTokenFirebase', empregado.id, { root: true })
    if (confirmar_dados) {
      router.push({ name: 'confirmacaoDados' })
      return
    }
    commit('marcacao/atribuilocalId', localRepp, {root: true})
    commit('marcacao/atribuiLocalDeTrabalhoMarcacao', localDeTrabalho, {root: true})
    router.push({ name: 'marcacao' })
  }
}

export default {
  namespaced: true,
  state: estadoPadrao(),
  getters,
  actions,
  mutations
}
